export class Contact {
    constructor(
        public name: string,
        public email: string,
        public phone: number,
        public company: string,
        public req_services: boolean
    ){}
}
